import type { CellContext } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { useContext } from 'react';
import Input from '@/components/UI/Form/Input';
import ReactSelect from '@/components/UI/Form/ReactSelect';
import { TableRowContext } from '@/features/ChangeOrder/Summary/Table/TableRowContext';
import type { ColMeta } from '@/features/ChangeOrder/Summary/Table/types';
import { formatDate3 } from '@/utils';

export function EditableCell({ column, row, cell }: CellContext<any, any>) {
  const columnMeta = column.columnDef.meta as ColMeta | undefined;
  const { editedRow, setEditedRow, isEditing } = useContext(TableRowContext);
  const currentValue = editedRow?.[column.id] || cell.getValue() || null;

  const asyncOptions = columnMeta?.useOptionsHook?.();

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditedRow((prevState) => ({
      ...prevState,
      [column.id]: e.target.value,
    }));
  };

  const onSelectChange = (newValue: unknown) => {
    setEditedRow((prevState) => ({
      ...prevState,
      [column.id]: newValue,
    }));
  };

  if (isEditing) {
    console.log(columnMeta?.type, column.id);
    return columnMeta?.type === 'select' ? (
      <ReactSelect options={asyncOptions || columnMeta?.options || []} onChange={onSelectChange} value={currentValue} />
    ) : columnMeta?.type === 'date' ? (
      <Input type={columnMeta?.type || 'text'} value={formatDate3(currentValue, 'yyyy-mm-dd')} onChange={onInputChange} />
    ) : (
      <Input type={columnMeta?.type || 'text'} value={currentValue} onChange={onInputChange} />
    );
  }

  if (columnMeta?.renderValue) {
    return columnMeta.renderValue({ row, cell });
  }

  if (columnMeta?.type === 'date') {
    return dayjs(currentValue).format('MM-DD-YYYY');
  }

  return <>{currentValue}</>;
}
